module.exports = __webpack_public_path__ + "static/media/1POLICY38.4dd9006b.jpg";